import React, { useState, useEffect, useRef } from 'react';
import './Css/MRDemoPage.css';

const MRDemoPage = () => {
  const [items, setItems] = useState([]);
  const [storeName, setStoreName] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const furnitureGridRef = useRef(null);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const storeId = query.get('storeId');
    console.log('MRDemoPage: Extracted query parameters', { storeId });

    const fetchStoreItems = async () => {
      if (!storeId) {
        console.log('MRDemoPage: Missing storeId, cannot fetch store');
        setError('Invalid store link. Missing store ID.');
        setLoading(false);
        return;
      }

      const fetchUrl = `https://firestore.googleapis.com/v1/projects/xyronis-8cc09/databases/(default)/documents/stores/${storeId}`;
      console.log('MRDemoPage: Fetching store data from URL', fetchUrl);

      try {
        const response = await fetch(fetchUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        console.log('MRDemoPage: Fetch response status', response.status);
        const responseText = await response.text();
        console.log('MRDemoPage: Raw response text', responseText);

        if (response.ok) {
          const data = JSON.parse(responseText);
          console.log('MRDemoPage: Parsed response data', data);

          if (data.fields) {
            const fields = data.fields;
            setStoreName(fields.name?.stringValue || 'Mixed Reality Store');
            setItems(fields.items?.arrayValue?.values?.map(item => {
              const itemFields = item.mapValue.fields;
              return {
                id: itemFields.id.stringValue,
                itemName: itemFields.itemName.stringValue,
                glbUrl: itemFields.glbUrl.stringValue,
                imageUrl: itemFields.imageUrl?.stringValue || null,
                timestamp: itemFields.timestamp.stringValue,
              };
            }) || []);
          } else {
            console.log('MRDemoPage: No store data found in response');
            setError('Store not found.');
          }
        } else {
          console.log('MRDemoPage: Fetch failed with status', response.status);
          setError(`Failed to fetch store: ${responseText}`);
        }
      } catch (err) {
        console.log('MRDemoPage: Error during fetchStoreItems', err);
        setError(`Error fetching store: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchStoreItems();
  }, []);

  useEffect(() => {
    if (loading || error || items.length === 0 || !furnitureGridRef.current) return;

    furnitureGridRef.current.innerHTML = '';

    items.forEach(item => {
      const itemDiv = document.createElement('div');
      itemDiv.className = 'furniture-item';
      const img = document.createElement('img');
      img.src = item.imageUrl || 'assets/placeholder.jpg';
      img.alt = item.itemName;
      const idText = new Text(item.itemName);
      itemDiv.appendChild(img);
      itemDiv.appendChild(idText);
      furnitureGridRef.current.appendChild(itemDiv);
    });
  }, [loading, error, items]);

  const handleLaunchMrDemo = () => {
    const queryString = window.location.search ? window.location.search.substring(1) : '';
    const targetUrl = queryString ? `mr-demo.html?${queryString}` : 'mr-demo.html';
    console.log('MRDemoPage: Navigating to mr-demo.html with URL:', targetUrl);
    console.log('MRDemoPage: Full URL:', `${window.location.origin}/${targetUrl}`);

    setTimeout(() => {
      if (navigator.xr) {
        navigator.xr.isSessionSupported('immersive-ar')
          .then(supported => {
            if (supported) {
              window.location.href = targetUrl;
            } else {
              window.open(
                'https://www.oculus.com/open_url/?url=' + encodeURIComponent(targetUrl),
                '_blank'
              );
            }
          })
          .catch(err => {
            console.error('Error checking WebXR support:', err);
            window.open(
              'https://www.oculus.com/open_url/?url=' + encodeURIComponent(targetUrl),
              '_blank'
            );
          });
      } else {
        window.open(
          'https://www.oculus.com/open_url/?url=' + encodeURIComponent(targetUrl),
          '_blank'
        );
      }
    }, 100);
  };

  if (loading) {
    return <div className="mr-demo-loading">Loading...</div>;
  }

  if (error) {
    return <div className="mr-demo-error">{error}</div>;
  }

  return (
    <div className="mr-demo-container">
      <h1 className="mr-demo-title">{storeName}</h1>
      <div ref={furnitureGridRef} className="mr-demo-grid"></div>
      <div className="mr-demo-button-container">
        <button onClick={handleLaunchMrDemo} className="mr-demo-button">
          Launch MR Demo
        </button>
      </div>
    </div>
  );
};

export default MRDemoPage;